var _rect, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoboticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.0645,
    y: 74.6292,
    width: 37.0646,
    height: 37.0646,
    transform: "rotate(-90 37.0645 74.6292)",
    fill: "#A0D7EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.129 0.5V37.5646H37.0645L74.129 0.5Z",
    fill: "#05A879"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5323,
    cy: 19.0324,
    r: 18.5323,
    transform: "rotate(-90 18.5323 19.0324)",
    fill: "#438991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0645 37.5647L37.0645 74.6293L18.5322 74.6293C8.29708 74.6293 -9.92244e-05 66.3321 -0.000100567 56.097C-0.000101909 45.8619 8.29708 37.5647 18.5322 37.5647L37.0645 37.5647Z",
    fill: "#FF7DA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoboticsIcon);
export default __webpack_public_path__ + "static/media/roboticsIcon.73223d19270d6083785ae1569f756f8b.svg";
export { ForwardRef as ReactComponent };